import { FiBarChart2, FiMusic, FiSmile, FiSpeaker, FiTarget } from "react-icons/fi"

export const IconCustom = ({ icon="default" }) => {

  const myIcon = {
    "default":<FiSmile />,
    "chart":<FiBarChart2 />,
    "music":<FiMusic />,
    "studio":<FiSpeaker />,
    "target":<FiTarget />
  }
  return (
    <span className="text-4xl font-black text-slate-50 rounded-full border bg-gradient-to-r from-orange-400 to-rose-400 2xl:w-24 2xl:h-24 w-16 h-16 flex items-center justify-center order-first">{myIcon[icon]}</span>
  )
}   